import { gql } from "graphql-request";

export const WorksheetFieldsFragment = gql`
  fragment WorksheetFieldsFragment on WorksheetSearchResult {
    worksheetId
    name
    subdomain
    budgetId
    budgetName
    proposalId
    proposalName
    ledgerType
    hasLinkedWorkforce
  }
`;
